export interface PrescriptionData {
  prescriptionId: string;
  name: string;
  SPH: {
    OD: number | undefined;
    OS: number | undefined;
  };
  CYL: {
    OD: number | undefined;
    OS: number | undefined;
  };
  AX: {
    OD: number | undefined;
    OS: number | undefined;
  };
  ADD: {
    OD: number | undefined;
    OS: number | undefined;
  };
  BC: {
    OD: number | undefined;
    OS: number | undefined;
  };
  DIA: {
    OD: number | undefined;
    OS: number | undefined;
  };
  rightCatentryId: number;
  leftCatentryId: number;
  rightCatentryParentId: number;
  leftCatentryParentId: number;
  lastUpdate: string;
  issueDate: string | null;
  expireDate: string | null;
  default: boolean;
  origin: PrescriptionOrigin;

  // Doctor details
  doctor?: string;
  clinic?: string;
  doctorAddress?: string;
  doctorState?: string;
  doctorFax?: string;

  // Submission method
  fileName?: string;
}

export interface LensPrescription {
  CL_POWER?: string;
  CL_BASE_CURVE?: string;
  CL_SPHERE_POWER?: string;
  CL_DIAMETER?: string;
  CL_DOMINANCE?: string;
  CL_ADDITION?: string;
}

export enum PrescriptionOrigin {
  STORE = "STORE",
  ONLINE = "ONLINE",
}
